<script>
import {Tag} from "element-ui"

export default {
  name: "sendState",
  props: {
    state: {
      type: String,
      default: ''
    }
  },
  // eslint-disable-next-line vue/require-render-return
  render(createElement, context) {
    if (this.is_Empty(this.$props.state)) return null;
    let state = {
      1: {text: "待发货", type: "danger"},
      2: {text: "部分发货", type: "warning"},
      3: {text: "已全部发货", type: "success"},
      4: {text: "已收货", type: "primary"},
    }
    let obj = state[this.$props.state] || {text: "异常", type: "danger"};
    return createElement(Tag, {
      props: {
        type: obj.type,
        size: "small"
      }
    }, obj.text)

  }
}
</script>


<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/page/me/salesOrder/component/sendState.vue